import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const UGCLosAngeles = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 100);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <>
      <Helmet>
        <title>UGC Agency Los Angeles | AI UGC Creator LA | Fuel72</title>
        <meta
          name="description"
          content="UGC Agency Los Angeles: Professional AI UGC videos for LA businesses. UGC Creator LA without influencers. 72-hour delivery. ✓ Local ✓ Fast ✓ Affordable"
        />
        <meta
          name="keywords"
          content="ugc agency los angeles, ugc creator la, ugc los angeles, ai ugc la, ugc videos los angeles, content creator la, ugc advertising la, ugc hollywood"
        />
        <link rel="canonical" href="https://www.fuel72.com/ugc-los-angeles" />
        
        <link rel="alternate" hrefLang="en" href="https://www.fuel72.com/ugc-los-angeles" />
        <link rel="alternate" hrefLang="en-US" href="https://www.fuel72.com/ugc-los-angeles" />
        <link rel="alternate" hrefLang="x-default" href="https://www.fuel72.com/ugc-los-angeles" />
        
        <meta property="og:title" content="UGC Agency Los Angeles | AI UGC Creator LA | Fuel72" />
        <meta property="og:description" content="AI UGC videos for LA businesses. Fast, professional, affordable." />
        <meta property="og:url" content="https://www.fuel72.com/ugc-los-angeles" />
        <meta property="og:locale" content="en_US" />
        
        <meta name="geo.region" content="US-CA" />
        <meta name="geo.placename" content="Los Angeles" />
        <meta name="geo.position" content="34.0522;-118.2437" />
        <meta name="ICBM" content="34.0522, -118.2437" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Fuel72 - UGC Agency Los Angeles",
            "description": "Professional AI UGC videos for Los Angeles businesses. Create UGC content without filming.",
            "url": "https://www.fuel72.com/ugc-los-angeles",
            "telephone": "+4917687870011",
            "email": "hello@fuel72.com",
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Los Angeles",
              "addressRegion": "CA",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "34.0522",
              "longitude": "-118.2437"
            },
            "areaServed": { "@type": "City", "name": "Los Angeles" },
            "priceRange": "$$"
          })}
        </script>
      </Helmet>

      <main className="min-h-screen gradient-mesh flex items-center justify-center">
        <div className="container mx-auto px-4 py-20 text-center">
          <h1 className="text-4xl md:text-6xl font-heading font-bold mb-6">
            UGC Agency{" "}
            <span className="bg-gradient-to-r from-neon-purple via-neon-pink to-orange-500 bg-clip-text text-transparent">
              Los Angeles
            </span>
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto mb-8">
            Professional AI UGC videos for LA businesses. 
            Entertainment, beauty, fitness – we make you visible.
          </p>
          
          <div className="max-w-3xl mx-auto text-left space-y-6">
            <h2 className="text-2xl font-bold">UGC for Los Angeles Businesses</h2>
            <p className="text-muted-foreground">
              Los Angeles is the entertainment and influencer capital. With Fuel72, LA businesses 
              get Hollywood-quality UGC videos without the Hollywood prices – delivered in 72 hours.
            </p>
            
            <h2 className="text-2xl font-bold mt-8">Industries in LA</h2>
            <ul className="space-y-2 text-muted-foreground">
              <li>🎬 Entertainment & Media</li>
              <li>💄 Beauty & Cosmetics</li>
              <li>💪 Fitness & Wellness</li>
              <li>🛍️ Fashion & Retail</li>
              <li>🍔 Restaurants & Hospitality</li>
              <li>🏠 Real Estate</li>
            </ul>
            
            <h2 className="text-2xl font-bold mt-8">Why Fuel72 for LA?</h2>
            <ul className="space-y-3 text-muted-foreground">
              <li>✅ <strong>Cheaper</strong> – $297 instead of $500-2000 per creator</li>
              <li>✅ <strong>Faster</strong> – 72 hours instead of weeks</li>
              <li>✅ <strong>Scalable</strong> – Unlimited content production</li>
              <li>✅ <strong>No risk</strong> – Consistent quality every time</li>
            </ul>
          </div>
          
          <p className="text-sm text-muted-foreground mt-12">Redirecting to main page...</p>
        </div>
      </main>
    </>
  );
};

export default UGCLosAngeles;